import React from "react";

function ImageInFormDisplay({ data }) {
  return <img src={data.photoURL} style={{ width: "100%" }} />;
}

export default ImageInFormDisplay;
